import { useMutation, useQueryClient } from '@tanstack/react-query'

import { graphql_call as graphql_admin_call } from '../../schemas/server_admin_query.ts'

import { mutation_update_fund_asset_notable } from './fund_graphql.ts'
import { keys } from './keystore.ts'

export interface UpdateFundAssetNotableInput {
  fundId: string
  assetId: string
  notable: boolean
}

export interface UpdateFundAssetNotableResponse {
  errors: string[]
  fund_asset: {
    id: string
    notable: boolean
    asset: {
      id: string
      name: string
    }
  } | null
}

export function useUpdateFundAssetNotable() {
  const queryClient = useQueryClient()

  return useMutation<
    UpdateFundAssetNotableResponse,
    Error,
    UpdateFundAssetNotableInput
  >({
    mutationFn: async (
      input: UpdateFundAssetNotableInput,
    ): Promise<UpdateFundAssetNotableResponse> => {
      const response = await graphql_admin_call({
        query: mutation_update_fund_asset_notable,
        variables: {
          fund_id: input.fundId,
          asset_id: input.assetId,
          notable: input.notable,
        },
      })

      if (!response) {
        throw new Error('No response received')
      }

      const result = response as UpdateFundAssetNotableResponse

      if (result.errors.length > 0) {
        throw new Error(result.errors.join(', '))
      }

      return result
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: keys.admin_funds.assets(variables.fundId).queryKey,
      })
    },
  })
}
